import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

const Blog = () => {
    return (
        <>
            <Navbar />
            <div className="under-construction">Under construction</div>
            <Footer />
        </>
    )
}
export default Blog;